import React, { useState } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleAboutClick = () => {
    if (window.location.pathname === '/') {
      // 如果在首頁，直接滾動到關於我們區域
      const aboutSection = document.getElementById('about');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 如果不在首頁，先導航到首頁再滾動
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleContactClick = () => {
    if (window.location.pathname === '/') {
      // 如果在首頁，直接滾動到聯絡我們區域
      const contactSection = document.getElementById('contact');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // 如果不在首頁，先導航到首頁再滾動
      window.REACT_APP_NAVIGATE('/');
      setTimeout(() => {
        const contactSection = document.getElementById('contact');
        if (contactSection) {
          contactSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const handleNavigation = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    // 導航後滾動到頁面頂部
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <a href="/" className="cursor-pointer">
              <h1 className="text-xl font-bold text-red-600" style={{ fontFamily: '"Pacifico", serif' }}>
                焯峯工程
              </h1>
            </a>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => handleNavigation('/village-house-declaration')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">村屋僭建物申報</button>
            <button onClick={() => handleNavigation('/t1-technician')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">T1技術人員</button>
            <button onClick={() => handleNavigation('/t3-technician')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">T3技術人員</button>
            <button onClick={handleAboutClick} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">關於我們</button>
            <button onClick={handleContactClick} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer">聯絡我們</button>
            <a 
              href="https://wa.me/85291898819"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp諮詢
            </a>
          </div>
          
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-red-600 cursor-pointer"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>
        
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col space-y-4">
              <button onClick={() => handleNavigation('/village-house-declaration')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer text-left">村屋僭建物申報</button>
              <button onClick={() => handleNavigation('/t1-technician')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer text-left">T1技術人員</button>
              <button onClick={() => handleNavigation('/t3-technician')} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer text-left">T3技術人員</button>
              <button onClick={handleAboutClick} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer text-left">關於我們</button>
              <button onClick={handleContactClick} className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer text-left">聯絡我們</button>
              <a 
                href="https://wa.me/85291898819"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-green-500 hover:bg-green-600 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap w-fit"
              >
                <i className="ri-whatsapp-line mr-2"></i>
                WhatsApp諮詢
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
